export const API_ROOT = process.env.REACT_APP_ENV_TYPE && process.env.REACT_APP_ENV_TYPE === 'PRODUCTION' ? 
                       'https://prod.api.kinnectedapp.com/v1' :  'https://dev.api.kinnectedapp.com/v1';
export const PIN_VERIFY = '/verifypin';
export const GET_TOPICS = '/topics';
export const SAVE_TOPICS = '/user/experience';
export const SELF_IMPROVEMENT = '/resources/selfimprovement';
export const EDUCATION = '/resources/education';
export const ENTREPRENEURSHIP = '/resources/entrepreneurship';
export const ALL_RESOURCES = '/resources';


// WEBPACK FOOTER //
// ./src/constants/apiRoutes.js